module.exports = __webpack_public_path__ + "6b445b934a48b45dba8a6c7ce4cf0a01.fbx";